module.exports = "./img/9fa2ec1da1524026efcd3137cceb17a3.png";